import { hexToRGB } from './hex-to-rgb';
import { rgbToHex } from './rgb-to-hex';

/**
 * Interpolates between two hex color values by a given ratio.
 *
 * Converts the input hex colors to RGB, then calculates the intermediate color
 * by linearly interpolating each channel (red, green, blue) based on the ratio.
 * The result is returned as a hex color string.
 *
 * @param colorA - The starting color in hex format (e.g., '#FF0000').
 * @param colorB - The ending color in hex format (e.g., '#00FF00').
 * @param ratio - The interpolation ratio between 0 and 1, where 0 returns colorA and 1 returns colorB.
 * @returns The interpolated color as a hex string.
 */
export const interpolate = (colorA: string, colorB: string, ratio: number): string => {
  const { blue: b1, green: g1, red: r1 } = hexToRGB(colorA);
  const { blue: b2, green: g2, red: r2 } = hexToRGB(colorB);

  return rgbToHex({
    alpha: 1,
    blue: b1 + (b2 - b1) * ratio,
    green: g1 + (g2 - g1) * ratio,
    red: r1 + (r2 - r1) * ratio,
  });
};
